export function isSuperAdminRole(role: string | null | undefined): boolean {
  if (!role) return false;
  const normalized = role.trim().toLowerCase();
  return normalized === 'super_admin' || normalized === 'super-admin' || normalized === 'superadmin';
}
